import React, { useEffect, useRef } from 'react';
 
interface ScorecardProps {
  eventId: string;
  theme?: 'light' | 'dark';
  lang?: string;
  maxHeight?: string;
}
 
const GeniePremiumScoreCard = ({
  eventId,
  theme,
  lang,
  maxHeight,
}: ScorecardProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const containerId = `scorecard-container`; // Unique ID for the container
 
  useEffect(() => {
    const scriptId = 'scorecard-sdk-script';
 
    const initializeScorecard = () => {
      (window as any).ScorecardSDK?.loadScorecard({
        containerId: containerRef.current.id,
        eventId,
        baseUrl: "https://scorecard.indisports.live",
        theme,
        lang,
        maxHeight,
      });
    };
 
    // Check if the script is already added to the page
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://sdk.indisports.live/scorecard-sdk.umd.js'; // Replace with your CDN URL
      script.async = true;
      script.onload = () => {
        console.log('Scorecard SDK script loaded from CDN.');
        initializeScorecard();
      };
      script.onerror = () => {
        console.error('Failed to load Scorecard SDK script from CDN.');
      };
      document.body.appendChild(script);
    } else {
      // If the script is already on the page, just initialize the scorecard
      initializeScorecard();
    }
  }, [eventId, theme, lang, maxHeight]); // Re-initialize if props change
 
  return <div id={containerId} ref={containerRef} />;
};
 
export default GeniePremiumScoreCard;